import { useEffect } from 'react';

export default function RecaptchaV3() {
  useEffect(() => {
    // Ensure grecaptcha script is present
    if (!window.grecaptcha) {
      const script = document.createElement('script');
      script.id = 'recaptcha-script';
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_GOOGLE_RECAPTCHA_V3_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    return () => {
      // clean up
      document.getElementById('recaptcha-script')?.remove();
      delete window.grecaptcha;
    };
  }, []);

  // show badge when recaptcha is rendered, hide when recaptcha is unmounted
  useEffect(() => {
    document.body.classList.add('show-recaptcha');
    document.body.classList.remove('hide-recaptcha');

    return () => {
      document.body.classList.remove('show-recaptcha');
      document.body.classList.add('hide-recaptcha');
    };
  }, []);

  return null;
}
